import { render, staticRenderFns } from "./IndexHyData6.vue?vue&type=template&id=2947197e"
import script from "./IndexHyData6.vue?vue&type=script&lang=js"
export * from "./IndexHyData6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports